import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useWidget } from 'widgets/sdk';

import { DEFAULT_SUBMIT_BACKGROUND_COLOR } from '../../MultipleChoicesWidget.config';
import { MultipleChoicesWidgetData } from '../../MultipleChoicesWidget.types';
import { MultipleChoicesSettingsColorPicker } from './MultipleChoicesSettingsColorPicker';

export const SubmitBgColor = () => {
  const { t } = useTranslation('editor_widget_toolbar', { keyPrefix: 'multipleChoicesToolbar', useSuspense: false });
  const { submitBackgroundColor = DEFAULT_SUBMIT_BACKGROUND_COLOR, updateWidget } =
    useWidget<MultipleChoicesWidgetData>();

  const handleChange = useCallback(
    (color: string) => {
      updateWidget({ submitBackgroundColor: color });
    },
    [updateWidget],
  );

  return (
    <MultipleChoicesSettingsColorPicker
      label={t('settingsSideBar.multipleChoices.submitButton.bgColorLabel')}
      color={submitBackgroundColor}
      onChange={handleChange}
    />
  );
};

SubmitBgColor.displayName = 'SubmitBgColor';
